import _ from 'lodash';
import { login } from './login';

export default _.merge(login);
